const h1 = 'prose-h1:font-serif prose-h1:font-bold prose-h1:text-grey-900 prose-h1:text-32 lg:prose-h1:text-48 prose-h1:tracking-title prose-h1:leading-title'
const h2 = 'prose-h2:font-serif prose-h2:font-bold prose-h2:text-grey-900 prose-h2:text-24 lg:prose-h2:text-36 prose-h2:tracking-title prose-h2:leading-title'
const h3 = 'prose-h3:font-serif prose-h3:font-bold prose-h3:text-grey-900 prose-h3:text-20 lg:prose-h3:text-24 prose-h3:tracking-title prose-h3:leading-title'

const p = 'prose-p:text-grey-750 prose-p:leading-22 prose-p:text-15'
const a = 'prose-a:text-primary'
const figcaption = 'prose-figcaption:text-center'

const figure = 'prose-figure:p-0'

const ul = 'prose-ul:list-none prose-ul:flex prose-ul:p-0 prose-ul:gap-10'
const li = 'prose-li:flex-shrink prose-li:p-0'

export {
  p,
  a,
  figcaption,
  figure,
  ul,
  li,
  h1,
  h2,
  h3,
}
